/// <amd-module name="VC/Common/Utils/Date" />

import { ago } from "VSSUI/Utilities/Date";

/**
 * Returns true if difference between @param date and the current time is less than 24 hours. Returns false otherwise.
 * @param date
 */
export function isDateRecent(date: Date): boolean {
    if (!date) {
        return false;
    }

    const oneHourInMilliseconds: number = 60 * 60 * 1000;
    const dateNow: Date = new Date();

    return (Math.abs(dateNow.getTime() - date.getTime()) / oneHourInMilliseconds) < 24;
}

/**
 * Returns the appropriate string representation of the date given.
 * If the date given is recent, this returns a string such as "7 hours ago".
 * Otherwise, this returns a string such as "2/29/2016".
 */
export function getDateString(date: Date, isDateRecent: boolean, dateOnly: boolean = false): string {
    if (!date) {
        return "";
    }

    return isDateRecent ? ago(date)
        : ( dateOnly ? date.toLocaleDateString() : date.toLocaleString());
}
